import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentMethodIndexComponent } from './crud-index/crud-index.component';
import { PaymentMethodCESComponent } from './crud-ces/crud-ces.component';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';

const routes: Routes = [
  {
    path: '',
    component: PaymentMethodIndexComponent,
  },
  {
    path: 'new',
    component: PaymentMethodCESComponent,
    data: { type: TypeCesEnum.NEW },
  },
  {
    path: 'show/:id',
    component: PaymentMethodCESComponent,
    data: { type: TypeCesEnum.SHOW },
  },
  {
    path: 'edit/:id',
    component: PaymentMethodCESComponent,
    data: { type: TypeCesEnum.EDIT },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PaymentMethodsRoutingModule {}
